import React from 'react';
import PaymentExportAllExportItem from '../../../../Domain/PaymentExportAllExportItem';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import PaymentExportAllExportService from '../../../../Services/PaymentExportAllExportService';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ShownOverWindowsEnum from '../../../../Enums/ShownOverWindowsEnum';
import UploadPanelDescription from '../UploadPanelDescription';
import UploadItem from '../UploadItem';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';

export default class PaymentExportDetailsInfoTab extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      exportId: urlParams.get('id'),
      loading: true,
      shownOverWindow: ShownOverWindowsEnum.None,
    };
  }

  componentDidMount() {}

  closeOverWindow() {
    this.setState({ shownOverWindow: ShownOverWindowsEnum.None });
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.UploadXml) {
      const tempEdited = new UploadItem({ exportId: this.state.exportId, file: null });
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={tempEdited}
          clickOnCancel={this.closeOverWindow.bind(this)}
          clickOnSave={this.closeOverWindow.bind(this)}
          windowDescription={UploadPanelDescription}
          errorCode={'PEDIT01'}
        />
      );
    }

    return null;
  }

  getAdditionalButtons = () => {
    return [
      {
        iconName: 'fa-solid fa-file-xml',
        type: ButtonTypeEnum.NormalIconOnly,
        tooltip: 'Create XML',
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: () => this.setState({ shownOverWindow: ShownOverWindowsEnum.UploadXml }),
        roleKey: 'BE_Finance_XML_Conversion',
        condition: (item) => item.OfficeName === 'BARE Belgium' || item.OfficeName === 'BARE Hungary',
      },
    ];
  };

  render() {
    const additionalButtons = this.getAdditionalButtons();
    const overWindow = this.renderOverWindows();
    return (
      <div>
        {overWindow}
        <ShowEntityData
          itemId={this.state.exportId}
          entityName='Payment Export Details'
          showHead={false}
          type={PaymentExportAllExportItem}
          serviceGetByIdFunction={PaymentExportAllExportService.GetById}
          additionalButtons={additionalButtons}
        />
      </div>
    );
  }
}
